<div class="row">
  <div class="col-12 col-md-12 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="employerName">
        Employer Name
        <span *ngIf="controlIsRequired('EmployerName')" class="color-error"
          >*</span
        >
      </label>
      <input
        class="form-control"
        id="employerName"
        placeholder="Employer name"
        type="text"
        [formControl]="getFormControl('EmployerName')"
        aria-label="Employer name"
      />
    </div>
  </div>
  <div class="col-12 col-md-12 col-lg-6">
    <div class="mb-3">
      <label class="form-label" for="position">
        Position/Title
        <span *ngIf="controlIsRequired('Position')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="position"
        placeholder="Position or title"
        type="text"
        [formControl]="getFormControl('Position')"
        aria-label="Position or title"
      />
    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <p>How long have you been employed?</p>
  </div>
</div>
<div class="row">
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="years">
        Years
        <span *ngIf="controlIsRequired('Years')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="years"
        placeholder=""
        type="number"
        [formControl]="getFormControl('Years')"
        aria-label="Years at current employer"
        min="0"
        step="1"
      />
    </div>
  </div>
  <div class="col-6 col-md-4 col-lg-2">
    <div class="mb-3">
      <label class="form-label" for="months">
        Months
        <span *ngIf="controlIsRequired('Months')" class="color-error">*</span>
      </label>
      <input
        class="form-control"
        id="months"
        placeholder=""
        type="number"
        [formControl]="getFormControl('Months')"
        aria-label="Months at current employer"
        max="11"
        min="0"
        step="1"
      />
    </div>
  </div>
</div>
